export function getAuthToken() {
  const raw = localStorage.getItem('token_b2b') || '';

  return raw.startsWith('Bearer ') ? raw : raw ? `Bearer ${raw}` : '';
}
